import type { IconProps } from './types';
import './icons.css';

export default function Show({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      className={`icon icon-show ${className || ''}`}
      fill="none"
    >
      <path
        d="M14.75 9.05c-.739-2.87-3.568-5.1-6.754-5.1-3.186 0-6.007 2.23-6.746 5.1"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M8 11.249a2.45 2.45 0 1 0 0-4.9 2.45 2.45 0 0 0 0 4.9Z"
        stroke="currentcolor"
        strokeMiterlimit="10"
      />
    </svg>
  );
}
